import * as React from "react";
const SvgFemale = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 17,
	height: 17,
	viewBox: "1 1 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M5.23291 7.01902C5.23291 5.2589 6.69545 3.83203 8.49958 3.83203C10.3037 3.83203 11.7662 5.2589 11.7662 7.01902C11.7662 8.62458 10.5493 9.95283 8.96624 10.1737V11.0028H10.0162C10.274 11.0028 10.4829 11.2066 10.4829 11.458C10.4829 11.7095 10.274 11.9133 10.0162 11.9133H8.96624V12.7101C8.96624 12.9615 8.75732 13.1654 8.49958 13.1654C8.24184 13.1654 8.03291 12.9615 8.03291 12.7101V11.9133H6.98291C6.72518 11.9133 6.51624 11.7095 6.51624 11.458C6.51624 11.2066 6.72518 11.0028 6.98291 11.0028H8.03291V10.1737C6.44984 9.95283 5.23291 8.62458 5.23291 7.01902ZM8.49958 4.7426C7.21091 4.7426 6.16624 5.76179 6.16624 7.01902C6.16624 8.27625 7.21091 9.29545 8.49958 9.29545C9.78823 9.29545 10.8329 8.27625 10.8329 7.01902C10.8329 5.76179 9.78823 4.7426 8.49958 4.7426Z",
	fill: "currentColor"
}));
export default SvgFemale;
